import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

// Must resolve before baseApi/middlewares are imported: rootReducer pulls in the
// persisted auth reducer first, which resolves the baseApi<->authSlice circular
// import through its safe direction. Importing baseApi directly first instead
// makes authApi.js hit `baseApi` before its own initialization (TDZ).
/* eslint-disable import/order */
import { rootReducers } from './rootReducer';

import { baseApi } from '@shared/api/baseApi.js';
import { authListenerMiddleware } from './middlewares';
/* eslint-enable import/order */

const stage = import.meta.env.MODE;

export const store = configureStore({
	reducer: rootReducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		})
			.concat(baseApi.middleware)
			.concat(authListenerMiddleware.middleware),

	devTools: stage === 'development',
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
